import { Helmet } from 'react-helmet-async';

/**
 * Block crawlers on non-production domains (staging, dev).
 * Only southcrete.com should be indexed for SEO.
 */
const NOINDEX_HOSTS = ['staging.southcrete.com', 'dev.southcrete.com'];

export default function NoIndexMeta() {
  const hostname = typeof window !== 'undefined' ? window.location?.hostname || '' : '';
  const shouldBlock = NOINDEX_HOSTS.includes(hostname);
  if (!shouldBlock) return null;

  return (
    <Helmet>
      <meta name="robots" content="noindex, nofollow" />
    </Helmet>
  );
}
